import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../context/LanguageContext';
import { Container } from '../ui/Container';
import CategoryCard from './CategoryCard';

const Section = styled.section`
  margin-bottom: 4rem;
  
  @media (min-width: 768px) {
    margin-bottom: 5rem;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

const HeaderText = styled.div`
  h2 {
    font-family: ${props => props.theme.typography.fonts.display};
    font-size: 1.75rem;
    font-weight: ${props => props.theme.typography.fontWeights.semibold};
    margin-bottom: 0.5rem;
    
    @media (min-width: 768px) {
      font-size: 2.25rem;
    }
    
    @media (min-width: 1024px) {
      font-size: 2.5rem;
    }
    
    @media (min-width: 1440px) {
      font-size: 2.75rem;
    }
  }
  
  p {
    color: ${props => props.theme.colors.mutedForeground};
    font-size: 1rem;
    
    @media (min-width: 1024px) {
      font-size: 1.125rem;
    }
  }
`;

const ViewAllLink = styled(Link)`
  display: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => props.theme.colors.mutedForeground};
  text-decoration: none;
  transition: color 0.2s;
  
  @media (min-width: 640px) {
    display: inline-flex;
  }
  
  &:hover {
    color: ${props => props.theme.colors.foreground};
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
  
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.75rem;
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  @media (min-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
  }
  
  @media (min-width: 1920px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 3rem;
  }
`;

const PopularCategories = ({ categories }) => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const categoriesUrl = language === 'en' ? '/categories' : `/${language}/categories`;
  
  return (
    <Section>
      <Container>
        <Header>
          <HeaderText>
            <h2>{t('section.popularCategories')}</h2>
            <p>{t('section.popularCategoriesDescription')}</p>
          </HeaderText>
          <ViewAllLink to={categoriesUrl}>{t('section.viewAllCategories')}</ViewAllLink>
        </Header>

        <Grid>
          {categories.map((category) => (
            <CategoryCard
              key={category.name || category.slug}
              name={category.name}
              slug={category.slug}
              color={category.color}
              imageUrl={category.imageUrl}
              postCount={category.postCount}
            />
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default PopularCategories;


